import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";

// --- CONFIGURATION FIREBASE ---
// Remplacez les valeurs ci-dessous par VOS vraies clés trouvées dans la console Firebase
// (Paramètres du projet > Général > Vos applications)
const firebaseConfig = {
  apiKey: "AIzaSyBxGgrGbvTerrhylVNMMnwYdZN1-rd68r8",
  authDomain: "facturation-c415d.firebaseapp.com",
  projectId: "facturation-c415d",
  storageBucket: "facturation-c415d.firebasestorage.app",
  messagingSenderId: "945272114804",
  appId: "1:945272114804:web:a8dc623ffdba4bf5efcb21"
};

// --- INITIALISATION ---
let app;
let auth;
let db;

try {
  // Vérification basique pour éviter les erreurs si la config est vide
  if (firebaseConfig.apiKey === "VOTRE_API_KEY_ICI") {
    console.warn("⚠️ Attention : Vous n'avez pas configuré vos clés Firebase dans src/lib/firebase.js");
    // On initialise quand même pour éviter le crash immédiat, mais les appels échoueront
    // Idéalement, ne rien faire ici ou lancer une erreur contrôlée
  }
  
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  
} catch (error) {
  console.error("Erreur d'initialisation Firebase :", error);
}

// Initialize Functions with region
const functions = getFunctions(app, 'us-central1');

// Initialize Storage
const storage = getStorage(app);

// --- EXPORTS ---
// C'est ici que l'erreur 'db is not exported' se produit si ces lignes manquent
export { auth, db, functions, storage };

// On exporte aussi l'appId pour l'organisation des dossiers (optionnel mais utilisé dans votre code)
export const appId = "batiflow-app";